import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Testimonials", href: "/testimonials" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Scroll to top on route change and reset scroll state
  useEffect(() => {
    window.scrollTo(0, 0);
    setScrolled(false);
  }, [location.pathname]);

  // Check if on home page for transparent navbar
  const isHome = location.pathname === "/";

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled || !isHome
            ? "bg-background-50/95 backdrop-blur-md shadow-sm"
            : "bg-transparent"
        }`}
      >
        <nav className="px-4 md:px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center group"
          >
            <span className="inline-flex items-center bg-white rounded-lg border-2 border-accent-500 px-2 py-1 transition-all duration-300 group-hover:border-accent-600">
              <img
                src="/images/logo.webp"
                alt="Askari Security Services logo"
                className="h-11 md:h-14 w-auto"
              />
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8 lg:gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-accent-500 whitespace-nowrap ${
                  scrolled || !isHome ? "text-foreground-700" : "text-background-50/90"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="text-sm font-semibold bg-accent-500 hover:bg-accent-600 text-background-50 px-5 py-2.5 rounded-md transition-all duration-300 whitespace-nowrap"
            >
              Request a Quote
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? "text-foreground-700" : "text-background-50"
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-2xl`} />
          </button>
        </nav>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-background-50 transition-all duration-500 md:hidden ${
          mobileMenuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map((link, index) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMobileMenuOpen(false)}
              className="text-2xl font-heading font-medium text-foreground-700 hover:text-accent-500 transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileMenuOpen(false)}
            className="mt-4 text-lg font-semibold bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3 rounded-md transition-all duration-300 whitespace-nowrap"
          >
            Request a Quote
          </Link>
        </div>
      </div>
    </>
  );
}